import React from "react";
import PropTypes from "prop-types";

const RoundSpinner = (props) => {
	return (
		<div style={{ transform: props.scale ? `scale(${props.scale})` : "" }}>
			<div className="round-spinner">
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-1" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-2" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-3" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-4" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-5" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-6" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-7" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-8" />
			</div>
		</div>
	);
};

RoundSpinner.defaultProps = {
	color: "#000000",
};

RoundSpinner.propTypes = {
	scale: PropTypes.number,
	color: PropTypes.string,
};

export default RoundSpinner;
